import { FadeIn, FadeOut } from "slotworks/graphics/animation/base-animations";
import Layers from "slotworks/graphics/layers/layers";
import { AbstractSceneTransition } from "slotworks/graphics/layers/scene-transitions/abstract-scene-transition";
import Contract from "slotworks/utils/contracts/contract";

export default class FadeTransition extends AbstractSceneTransition {

    private duration: number;

    constructor(layer: Layers, duration: number) {
        super(layer);

        this.duration = duration;
    }

    public in(): Contract<void> {
        if (this.layer) {
            return FadeIn(this.layer.container, this.duration);
        }

        return Contract.empty();
    }

    public out(): Contract<void> {
        if (this.layer) {
            return FadeOut(this.layer.container, this.duration);
        }

        return Contract.empty();
    }
}
